
<template>
  <div class="org-external-transaction-tab">
    <ExternalTransactionRecordTable
      v-loading="loading.table"
      :tableData="tableData"
      :enable-columns="['shopName']"
      :externalData="{ shopList }"
      :fetch-transactions-api="GetOrgExternalTransaction"
      :find-record-api="FindOrgExternalTransaction"
      :options="{
        showBranch: false,
        showPhone: false,
      }"
      @refresh="refresh(false)"
    />
    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="tableDataCount"
      @pageChange="refresh(false)"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { onMounted, onActivated, onBeforeMount, defineComponent, ref } from 'vue'
import { useTable } from '@/use/table'
import {
  GetOrgExternalTransaction,
  GetOrgExternalTransactionCount,
  FindOrgExternalTransaction,
} from '@/api/memberExternalTransaction'
import ExternalTransactionRecordTable from '@/components/ExternalTransaction/ExternalTransactionRecordTable.vue'
import { useFetch } from '@/use/fetch'
import { GetShops } from '@/api/shop'
import { apiFormatAdaptor } from '@/utils/api'

export default defineComponent({
  name: 'OrgExternalTransactionTab',
  components: {
    ExternalTransactionRecordTable,
  },
  props: ['member'],
  setup (props) {
    const {
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      pageStartIndex,
      shopId,
      fetchData,
      fetchDataCount,
    } = useTable()
    const { fetchAll } = useFetch()
    const shopList = ref([])

    onBeforeMount(async () => {
      fetchAll(apiFormatAdaptor(GetShops), null, (res) => {
        shopList.value = res
      })
    })

    const getTableData = async () => {
      const payload = {
        MemberId: get(props.member, 'id', undefined),
        shopId: shopId.value,
        start: pageStartIndex.value,
        limit: tableOptions.pageLimit,
      }
      await Promise.allSettled([
        fetchData(GetOrgExternalTransaction, payload),
        fetchDataCount(GetOrgExternalTransactionCount, payload),
      ])
    }
    const refresh = async (search = false) => {
      if (search) tableOptions.page = 1
      loading.table = true
      await getTableData()
      loading.table = false
    }
    onMounted(async () => {
      await refresh()
    })
    onActivated(async () => {
      await refresh()
    })
    return {
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      shopList,
      GetOrgExternalTransaction,
      FindOrgExternalTransaction,
      refresh,
    }
  },
})
</script>

<style scoped lang="scss">
</style>
